module.exports = __webpack_public_path__ + "img/venue-1.193bc96c.png";